<template>
<prismic-link target="_blank" :field="link">
  <div class="flex flex-col rounded  mx-auto  bg-white rounded-3xl pb-2 mb-12">
    <div class="flex flex-col w-ful w-full h-full bg-gray-200  rounded-3xl">
      <img  v-bind:src="this.image.url" class="object-top object-cover rounded-3xl  h-full"/>
    </div>
    <div class="flex  pt-4 px-5 flex-col">
      <prismic-rich-text class="leading-normal font-display mb-2" :field="this.body" />
      <p class="text-sm text-gray-500 mb-2">{{this.price}} zł</p>
      
      <div class="inline-flex items-center bg-white leading-none text-fuchsia-900  px-0 py-1 text-md">
        <span class="inline-flex pr-2 text-gray-500">
          Zobacz w sklepie
        </span>
        <img class="fill-current" src=" data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAQElEQVR42qXKwQkAIAxDUUdxtO6/RBQkQZvSi8I/pL4BoGw/XPkh4XigPmsUgh0626AjRsgxHTkUThsG2T/sIlzdTsp52kSS1wAAAABJRU5ErkJggg== " alt="" />
      </div>
    </div>
  </div>
</prismic-link>
</template>

<script>

export default {
    name: 'ShopBox',
    components: {},
    props: {
        image: Object,
        price: Number,
        link: Object,
        body: Array
  }
}
</script>
